import { createUserManager } from "redux-oidc";

const create = config => {
  const userManagerConfig = {
    client_id: "entryevent-browser",
    redirect_uri: `${config.self}/callback`,
    response_type: "token id_token",
    scope: "openid profile email entryevent",
    authority: config.authUrl,
    post_logout_redirect_uri: `${process.env.PUBLIC_URL}`,
    silent_redirect_uri: `${window.location.protocol}//${
      window.location.hostname
    }${
      window.location.port ? `:${window.location.port}` : ""
    }/silent_renew.html`,
    automaticSilentRenew: false,
    filterProtocolClaims: true,
    loadUserInfo: true
  };

  const userManager = createUserManager(userManagerConfig);

  return userManager;
};
export default create;
